import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContext } from "react";
import dateFormat from "dateformat";

import Thumbnail from "src/components/thumbnail";
import { SimulationReportContext } from "../../context";

import { UserGroup } from "src/types/users";

import _ from "lodash";
import cx from "classnames";
import styles from "./learners.module.scss";

interface LearnersListProps {
  selectedUserGroups?: UserGroup[];
}

export const LearnersList: React.FC<LearnersListProps> = ({
  selectedUserGroups = [],
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const simulationReportContext = useContext(SimulationReportContext)
  const learners = simulationReportContext.learners || [];

  const params = useParams();
  const id = params.id as string;
  const learningId = params.learningId as string;

  const handleSelectLearner = (learner: any) => {
    navigate(`/coaching/manage/simulations/${id}/reports/${learner.id}`, {
      state: {
        ...(location.state as object),
        ...(selectedUserGroups.length ? { selectedUserGroups } : {}),
      },
    });
  };

  return (
    <div className={styles.learnersList}>
      {learners.map((item, index) => (
        <div className={styles.learner} onClick={() => handleSelectLearner(item)}>
          <div
            className={cx(styles.left, {
              [styles.active]: item.id === learningId,
            })}
          >
            <div className={styles.details}>
              <Thumbnail
                media={item.user?.icon}
                defaultImage="/images/assets/default_asset.jpg"
                className={styles.icon}
              />

              <div className={styles.info}>
                <span className={styles.name}>
                  {item.user.firstName || ""} {item.user.lastName}
                  {item.status === "COMPLETED" && (
                    <i className="paperflite-flag" />
                  )}
                </span>

                <span className={styles.engagedDate}>
                  last call logged on{" "}
                  {dateFormat(item.modifiedDate, "dd mmm yyyy")}
                </span>
              </div>
            </div>
          </div>

          <div className={styles.progress}>{`${Math.round(item.score * 100)} %` || "na"}</div>
        </div>
      ))}
    </div>
  );
};
